import React, { FC } from 'react';

import { btnTypes } from '@r1-frontend/ui-react/components/buttons/baseButton';

import OpenChat from '~/src/components/OpenChatLink';
import { NON_BREAKING_SPACE } from '~/src/constants/simbols';

import * as ST from './styled';

interface IPopupResponseProps {
    type: string,
    isOpen: boolean,
    onClose: () => void,
    title: string,
    message?: string,
}

const PopupResponse: FC<IPopupResponseProps> = ({ type, title, message, isOpen, onClose }) => {
    return (
        <ST.ResponsePopup isOpen={isOpen} onClose={onClose}>
            <ST.IconBlock/>
            <ST.Title>{title}</ST.Title>
            <ST.Text>{message || ''}</ST.Text>
            {type === 'error' &&
                <ST.Text data-test='error-message'>
                    {`Пожалуйста, попробуйте позднее. В случае повторения ошибки, напишите нам в${NON_BREAKING_SPACE}`}
                    <span onClick={onClose}><OpenChat/></span>
                </ST.Text>
            }
            {type === 'success' &&
                <ST.Button
                    type={btnTypes.SECONDARY}
                    href='/'
                    data-test='begin-btn'
                >
                    Начать
                </ST.Button>
            }
        </ST.ResponsePopup>
    );
};

export default PopupResponse;
